/**
 * Detects iframe / embedded contexts (e.g. Microsoft Teams tabs).
 * Uses try/catch because cross-origin parent access throws.
 */
export function isEmbeddedContext(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function isTeamsContext(): boolean {
  if (!isEmbeddedContext()) return false;

  const referrer = document.referrer;
  const userAgent = navigator.userAgent;

  return (
    referrer.includes('teams.microsoft.com') ||
    referrer.includes('teams.live.com') ||
    userAgent.includes('Teams')
  );
}

export function isAuth0Configured(): boolean {
  const domain = import.meta.env.VITE_AUTH0_DOMAIN;
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;

  return (
    Boolean(domain && clientId) &&
    !String(domain).includes('<') &&
    !String(clientId).includes('<')
  );
}

/** Must match an Allowed Callback URL in Auth0 (usually the app origin). */
export function getAuth0RedirectUri(): string {
  const configured = import.meta.env.VITE_AUTH0_REDIRECT_URI?.trim();
  if (configured) return configured;
  return window.location.origin;
}

export function isAuth0RedirectCallback(): boolean {
  const params = new URLSearchParams(window.location.search);
  return params.has('code') && params.has('state');
}

export function isAuth0RedirectError(): boolean {
  const params = new URLSearchParams(window.location.search);
  return params.has('error');
}
